module.exports = __webpack_public_path__ + "static/media/social_icon_custom.4e84a27e.svg";